import React,{useEffect} from 'react';
import MapViewControl from './MapView.Control.jsx';
 
import { MapContainer, TileLayer, Marker, Popup, Polyline, FeatureGroup, useMap, Tooltip } from 'react-leaflet'

export default function tMapViewBounds({lowestLat,lowestLng,highestLat,highestLng}) {
    const parentMap = useMap(); 
    var lowestPoint=  [lowestLat, lowestLng];
    var highestPoint=  [highestLat, highestLng];

    useEffect(() => {
        parentMap.flyToBounds([
            lowestPoint,highestPoint
        ],{
            duration:0.25
        });
    }, [lowestLat,lowestLng,highestLat,highestLng]);
 
     if(false){
        return ( <><Marker position={lowestPoint}>
            <Tooltip>
                Lowest {JSON.stringify(lowestPoint)}
            </Tooltip>
        </Marker><Marker position={highestPoint}>
            <Tooltip>
                Highest {JSON.stringify(highestPoint)}
            </Tooltip>
        </Marker></>);
     }else{
        return (<></>);
     }
    

}
